import { SendMailQueue } from '@/domain/SendMailQueue'
import axios from 'axios'

/**
 * メール送信サービス（メール送信テスト用）
 */
export default class SendMailQueueService {
    /** インスタンス */
    private static _instance: SendMailQueueService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new SendMailQueueService();
        }
        return this._instance;
    }
    
    /**
     * メール送信キューへの登録
     */
    public async push(dto: SendMailQueue): Promise<SendMailQueue> {
        return await axios.post("/api/mail_queue/push", dto)
            .then((results) => {
                if (results.status === 200) {
                    return results.data as SendMailQueue
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
